// extracted by mini-css-extract-plugin
export default {"indicator":"ClearIndicator-module__indicator__gc+oH","icon":"ClearIndicator-module__icon__wk0RA"};